import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk to DeleteCategory 
export const DeleteCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ categoryId: id, categoryData, categoryType }, { rejectWithValue }) => {
    try {
      // Set a default category type in case it's invalid
      const validCategoryTypes = ["quantity", "package", "stock"];
      if (!validCategoryTypes.includes(categoryType)) {
        return rejectWithValue("Invalid category type");
      }

      let endpoint;
      switch (categoryType) {
        case "quantity":
          endpoint = `/Categories/${id}/Delete/`;
          break;
        case "package":
          endpoint = `/PackageCategories/${id}/Delete/`;
          break;
        case "stock":
          endpoint = `/ProductVouchers/${id}/Delete/`;
          break;
        default:
          return rejectWithValue("Invalid category type");
      }

      const response = await axios.delete(`${apiUrl}${endpoint}`, categoryData,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data; // Data returned from the API
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    isLoading: false,
    error: null,
    updatedCategory: null, // Store the updated category data
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(DeleteCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(DeleteCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updatedCategory = action.payload;
        state.error = null;
      })
      .addCase(DeleteCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default categoriesSlice.reducer;
